import { render, staticRenderFns } from "./rightZX.vue?vue&type=template&id=3aa28f41&scoped=true&"
import script from "./rightZX.vue?vue&type=script&lang=ts&"
export * from "./rightZX.vue?vue&type=script&lang=ts&"
import style0 from "./rightZX.vue?vue&type=style&index=0&id=3aa28f41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa28f41",
  null
  
)

export default component.exports